import TApplicationInviteUserSmsVerifyOtpInput from './index.vue';

TApplicationInviteUserSmsVerifyOtpInput.install = app => {
  app.component(TApplicationInviteUserSmsVerifyOtpInput.name, TApplicationInviteUserSmsVerifyOtpInput);
};

export default TApplicationInviteUserSmsVerifyOtpInput;
